import { Service } from '@phishtool/service';
import getEnterpriseQuotePortalController, { GetEnterpriseQuotePortalRequestDataSchema, } from '~server/controllers/service/enterprise-quote-portals/get-enterprise-quote-portal';
import { rateLimitMiddleware } from '~middleware';
export class EnterpriseQuotePortalService extends Service {
    constructor() {
        super(...arguments);
        this.useGetQuotePortal = this.addCollectiontonNonResourceMutation({
            controller: getEnterpriseQuotePortalController,
            schema: GetEnterpriseQuotePortalRequestDataSchema,
            middleware: [rateLimitMiddleware],
            routeId: 'get-quote-portal',
        });
    }
}
